import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "21",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      "fill-rule": "nonzero",
      stroke: "currentColor",
      "stroke-width": "1.8",
      fill: "none"
    }, [
      _createElementVNode("path", { d: "M14.857 1H6.143A5.149 5.149 0 0 0 1 6.143v8.714A5.149 5.149 0 0 0 6.143 20h8.714A5.149 5.149 0 0 0 20 14.857V6.143A5.149 5.149 0 0 0 14.857 1Z" }),
      _createElementVNode("path", { d: "M10.5 14.581A4.086 4.086 0 0 1 6.419 10.5 4.086 4.086 0 0 1 10.5 6.419a4.086 4.086 0 0 1 4.081 4.081c0 2.25-1.83 4.081-4.081 4.081ZM15.37 4.546c.625-.186.783-.115.898 0a.633.633 0 0 1-.449 1.084.633.633 0 0 1-.635-.635c0-.175.072-.334.187-.449Z" })
    ], -1)
  ])))
}
export default { render: render }